<div *ngIf="fulfillmentOrder" class="approvals-card">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>{{ 'PENDING_APPROVALS_CARD.TITLE' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngFor="let pendingActivation of fulfillmentOrder.pendingActivationIds">
        <div
          *ngIf="(fulfillmentOrder?.pendingActivationInfo?.activationStatuses?.[pendingActivation]) | isActivationPending"
          class="pending-activation-container"
        >
          <div class="inner-pending-activation-container">
            <glxy-avatar
              [src]="(fulfillmentOrder | getProductInfo | async)?.iconUrl"
              [name]="fulfillmentOrder?.appInfo?.appName"
            ></glxy-avatar>
            <span>{{ fulfillmentOrder?.appInfo?.appName || '' }}</span>
          </div>
          <div class="inner-pending-activation-container">
            <button mat-stroked-button color="warn" (click)="decline(pendingActivation)">
              {{ 'PENDING_APPROVALS_CARD.DECLINE' | translate }}
            </button>
            <button mat-flat-button color="primary" (click)="approve(pendingActivation)">
              {{ 'PENDING_APPROVALS_CARD.APPROVE' | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
